<template>
  <div id="super-clip" class="position-relative">
    <div class="social-nav filter-blur-50">
      <div class="nameContainer" :class="this.$lang === 'ar' ? 'right-dir' : ''">
        <router-link to="/personal" class="d-flex">
          <div class="homeIcon">
            <a><img src="../../assets/icons/homeIcon.svg" height="20px" width="20px"></a>
          </div>
        </router-link>
        <div class="arrowIcon" :class="this.$lang === 'ar' ? 'rotate' : ''">
          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
        </div>
        <router-link to="/profile" class="d-flex">
          <div class="featureTitle">
            {{$t('featureController.title')}}
          </div>
        </router-link>
        <div class="arrowIcon" :class="this.$lang === 'ar' ? 'rotate' : ''">
          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
        </div>
        <div class="titleName">{{main.title}}</div>
      </div>
    </div>
    <div style="min-height: calc(100vh - 289.08px); display: flex; align-items: center; justify-content: center; flex-direction: column; ">
      <div v-if="!showLoading && tab === 0 || tab === 1 || tab === 2" class="main-cont w-100">
        <div class="card-container">
          <br><br>
          <div :class="[this.$lang === 'ar' ? 'right-dir' : 'left-dir', 'wrapper']">
            <div class="header">
              <div class="flexing">
                <div :class="[this.$lang === 'ar' ? 'bold-ar': 'bold-en', 'titles']">{{ main.title }}</div>
                <label class="switch">
                  <input @click="activateFeature" v-model="main.checked" type="checkbox">
                  <span :style="{borderColor: main.checked ? '#FFCB05' : '', boxShadow: main.checked ? ' 0px 0px 5px rgb(205,203,5)' : ' 0px 0px 5px rgb(106,106,106)'}" class="slider"></span>
                  <div :style="{transform : main.checked ? 'translateX(1.2em)' : 'translateX(0em)'}" class="slider-border"></div>
                </label>
              </div>
              <div class="mini-title" :class="[this.$lang === 'ar' ? 'text-right' : 'text-left']">
                <span :class="this.$lang === 'ar' ? 'bold-ar' : 'bold-en'">{{ main.price }}</span>
              </div>
            </div>
            <div :class="[this.$lang === 'ar' ? 'regular-ar text-right' : 'regular-en text-left', 'description']" class="d-flex">
              {{main.description}}
            </div>
            <div class="d-flex super-note" :class="this.$lang === 'ar' ? 'text-right' : 'text-left'" v-if="tab === 0">{{$t('feature.superMessage')}}</div>
          </div>
          <!--          __________-->
          <div class="routed-sections">
            <div class="tabs-cont position-relative">
              <div class="tabs-white-border"></div>
              <v-tabs v-model="tab" fixed-tabs :class="this.$lang === 'ar' ? 'right-dir' : ''" >
                <v-tab v-for="(tab, i) in tabs" :key="i" :disabled="isLoading || showLoading">
                  <span :class="lang === 'ar' ? 'regular-ar' : 'regular-en'" style="text-transform: capitalize"> {{ tab }} </span>
                </v-tab>
              </v-tabs>
            </div>
            <v-tabs-items v-model="tab" :touchless="true">
              <div class="tabs-content">
                <!--                Service Status-->
                <v-tab-item>
                  <div class="routed-section">
                    <div class="options-cont position-relative" :class="this.$lang === 'ar' ? 'right-dir' : ''">
                      <div class="opacity-layout" v-if="!main.checked"></div>
                      <div class="w-100">
                        <div v-for="(item,i) in options" :key="i">
                          <div class="option">
                            <div class="d-flex align-items-center"><div class="ball-white-3"></div><span class="name" :class="$lang === 'ar' ? 'ml-2' : 'mr-2'">{{item.name}}</span><span class="desc d-sm-block d-none">{{item.desc}}</span></div>
                            <label class="switch">
                              <input @click="activateOption(i)" v-model="item.checked" type="checkbox">
                              <span :style="{borderColor: item.checked ? '#FFCB05' : '', boxShadow: item.checked ? ' 0px 0px 5px rgb(205,203,5)' : ' 0px 0px 5px rgb(106,106,106)'}" class="slider"></span>
                              <div :style="{transform : item.checked ? 'translateX(1.2em)' : 'translateX(0em)'}" class="slider-border"></div>
                            </label>
                          </div>
                          <span class="desc d-sm-none d-block mt-3" :class="$lang === 'ar' ? 'text-right' : 'text-left'">{{item.desc}}</span>
                          <!--                        <div class="d-flex input-cont">-->
                          <!--                          <img src="../../assets/icons/contactNumber.svg">-->
                          <!--                          <input :placeholder="$t('feature.enter')" v-model="item.value" :disabled="!item.checked">-->
                          <!--                        </div>-->
                          <div class="border-cont" v-if="i !== options.length - 1"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
                <!--                Auto Reply-->
                <v-tab-item>
                  <div class="routed-section">
                    <div class="options-cont" :class="this.$lang === 'ar' ? 'right-dir' : ''">
                      <Loader v-if="showLoading" />
                      <div v-else style="width: 90%; max-width: 909px">
                        <div class="option">
                          <div class="d-flex align-items-center"><div class="ball-white-3"></div><span class="name" :class="$lang === 'ar' ? 'ml-2' : 'mr-2'">{{$t('super.general')}}</span></div>
                        </div>
                        <span class="desc d-flex mt-3" :class="$lang === 'ar' ? 'text-right' : 'text-left'">{{$t('super.generalNote')}}</span>
                        <div class="d-flex input-cont w-100">
                          <img src="../../assets/icons/generalMessage.svg">
                          <input :placeholder="$t('super.generalPlace')" v-model="general">
                        </div>
                        <div class="border-cont"></div>
                        <div class="option">
                          <div class="d-flex align-items-center"><div class="ball-white-3"></div><span class="name" :class="$lang === 'ar' ? 'ml-2' : 'mr-2'">{{$t('super.exceptions')}}</span></div>
                        </div>
                        <span class="desc d-flex mt-3" :class="$lang === 'ar' ? 'text-right' : 'text-left'">{{$t('super.exceptionNote')}}</span>
                        <div v-for="(excep, i) in exceptions" :key="i" class="exceptions">
                          <div class="row">
                            <div class="col-12">
                              <div class="input-cont-1" style="height: auto !important; min-height: 50px; padding: 10px;">
                                <div class="d-flex align-items-center" style="height: 50px">
                                  <div class="num-item">
                                    <img src="../../assets/icons/contactNumber.svg">
                                    <input placeholder="09xxxxxxxx" v-model="excep.num" type="text" maxlength="10" oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                                    <div @click="addNumToList(excep.num, i)" class="add-num" v-if="valid(excep.num)">+</div>
<!--                                    v-if="excep.num.length === 10"-->
                                  </div>
                                </div>
                                <div style="max-height: 67px; overflow-y: auto;" :class="$lang === 'ar' ? 'text-right' : 'text-left'">
                                  <div class="d-inline-block" v-for="(num, j) in excep.numbers" :key="j">
                                    <div class="num-item">
                                      <span>{{num.value}}</span><span class="delete-num" v-if="!num.back" @click="deleteNum(i, j)">x</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div v-if="!valid(excep.num) && excep.num !== '' && showError2" :class="[lang === 'ar' ? 'right-align regular-ar' : 'left-align regular-en', 'validation']">{{$t('validation')}}</div>
                            </div>
                            <div class="col-12">
                              <div class="d-flex input-cont-1">
                                <img src="../../assets/icons/generalMessage.svg">
                                <input :placeholder="$t('super.generalPlace')" v-model="excep.message">
                              </div>
                            </div>
                            <div class="col-12 d-flex justify-content-center">
                              <div :class="i !== exceptions.length - 1 ? 'yellow-divider' : ''"></div>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex add-excep" @click="addException"> {{$t('super.addException')}} +</div>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
                <!--                My Calleres-->
                <v-tab-item>
                  <div class="routed-section">
                    <div class="options-cont-2" style="padding-bottom: 10rem" :class="this.$lang === 'ar' ? 'right-dir' : ''">
                      <Loader v-if="showLoading" />
                      <div v-show="!showLoading" style="width: 90%; max-width: 909px">
                        <div class="option">
                          <div class="d-flex align-items-center">
                            <span class="name">{{$t('super.myCallers')}}</span>
                          </div>
                        </div>
                        <span class="desc d-flex mt-3" :class="$lang === 'ar' ? 'text-right' : 'text-left'">{{$t('super.callersNote')}}</span>
                        <div class="row" style="margin-bottom: 2rem">
                          <div class="col-sm-6 col-12">
                            <div class="input-cont-1 d-flex align-items-center">
                              <Dropdown v-model="filterType" :options="types" optionLabel="name" dataKey="id" placeholder=""/>
                            </div>
                          </div>
                          <div class="col-sm-6 col-12">
                            <div class="d-flex input-cont-1 w-100">
                              <img src="../../assets/icons/contactNumber.svg">
                              <input :placeholder="$t('super.addNum')" v-model="callerGsm" type="text" maxlength="10" oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                            </div>
                            <div v-if="!valid(callerGsm) && this.callerGsm !== '' && showError3" :class="[this.$lang === 'ar' ? 'right-align regular-ar' : 'left-align regular-en', 'validation']">{{$t('validation')}}</div>
                          </div>
                        </div>
                        <div>
                          <div class="callers-layout">
                            <div class="opacity-0">
                              <div class="option">
                                <div class="d-flex align-items-center">
                                  <span class="name">{{$t('super.myCallers')}}</span>
                                </div>
                              </div>
                              <span class="desc d-flex mt-3" :class="$lang === 'ar' ? 'text-right' : 'text-left'">{{$t('super.callersNote')}}</span>
                              <div class="row" style="margin-bottom: 2rem">
                                <div class="col-sm-6 col-12">
                                  <div class="input-cont-1 d-flex align-items-center">
                                    <Dropdown v-model="filterType" :options="types" optionLabel="name" dataKey="id" placeholder=""/>
                                  </div>
                                </div>
                                <div class="col-sm-6 col-12">
                                  <div class="d-flex input-cont-1 w-100">
                                    <img src="../../assets/icons/contactNumber.svg">
                                    <input :placeholder="$t('super.addNum')" v-model="callerGsm" type="text" maxlength="10" oninput="this.value=this.value.replace(/[^0-9]/g,'');">
                                  </div>
                                  <div v-if="!valid(callerGsm) && this.callerGsm !== '' && showError3" :class="[this.$lang === 'ar' ? 'right-align regular-ar' : 'left-align regular-en', 'validation']">{{$t('validation')}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="option mb-3" style="min-height: 20px">
                            <div class="d-flex align-items-center">
                              <span class="name" v-if="callersList.length !== 0">{{$t('super.callersList')}}</span>
                            </div>
                          </div>
                          <div v-for="(call, i) in callersList" :key="i" class="my-2 d-flex justify-content-between">
                            <div>
                              <div class="item"> {{call.number}}</div>
                            </div>
                            <div>
                              <div class="item"> {{call.date}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
              </div>
            </v-tabs-items>
          </div>
        </div>
      </div>
      <div v-if="!showLoading && tab === 0 || tab === 1 || tab === 2" class="feature-footer" :class="this.$lang === 'ar' ? 'right-dir' : ''">
        <span class="cancel"  @click="tab === 0 ? showSuperClip() : tab === 1 ? showAutoReply() : tab === 2 ? lastDayCallers() : ''">
          {{$t('actions.cancel')}}
        </span>
        <span v-if="!isLoading" class="submit" @click="!isLoading && tab === 0 ? handleSubmit1() : !isLoading && tab === 1 ? handleAutoReply() : !isLoading && tab === 2 ? showCallers() : ''">
         {{$t('submit')}}
        </span>
        <div v-if="isLoading" class="spinner-border text-light" role="status"></div>
      </div>
      <Loader v-if="showLoading && tab === 0" style="padding-top: 160px;" />
    </div>
  </div>
</template>

<script>

import Dropdown from 'primevue/dropdown'
import $ from 'jquery'
import CallForwardRepository from '../../repositories/CallForwardRepository'
import SuperClipRepository from '../../repositories/SuperClipRepository'
import ms from '../../utils/messeging'
import Loader from '../LoaderBtn/Loader'
export default {
  name: 'superClip',
  components: { Loader, Dropdown },
  data () {
    return {
      showError2: false,
      showError3: false,
      show2: false,
      show3: false,
      counter: 0,
      counter2: 0,
      lang: this.$lang,
      types: [{ id: 0, name: '1 Day' }, { id: 1, name: '3 Day' }, { id: 2, name: '1 Week' }, { id: 3, name: '3 Week' }, { id: 4, name: '30 Last Days' }],
      callerGsm: '',
      callersList: [],
      filterType: { id: 0, name: '1 Day' },
      tabs: [this.$t('super.status'), this.$t('super.reply'), this.$t('super.callers')],
      general: '',
      exceptions: [{ num: '', message: '', numbers: [] }],
      tab: 0,
      isLoading: false,
      showLoading: false,
      callForwardRepo: new CallForwardRepository(),
      superClipRepo: new SuperClipRepository(),
      main: {
        id: null,
        checked: false,
        title: '',
        price: '',
        type: 0,
        description: ''
      },
      options: [
        {
          checked: false,
          name: this.$t('feature.busy'),
          desc: this.$t('super.busy'),
          value: ''
        },
        {
          checked: false,
          name: this.$t('feature.reach'),
          desc: this.$t('super.unReach'),
          value: ''
        },
        {
          checked: false,
          name: this.$t('feature.answer'),
          desc: this.$t('super.unReach'),
          value: ''
        },
        {
          checked: false,
          name: this.$t('feature.all'),
          desc: this.$t('super.all'),
          value: ''
        }
      ]
    }
  },
  created () {
    this.showSuperClip()
  },
  mounted () {
    this.style()
  },
  methods: {
    valid (val) {
      const regex = /^[0][9][0-9]{8}$/
      return regex.test(val)
    },
    deleteNum (i, j) {
      this.exceptions[i].numbers = this.exceptions[i].numbers.filter((num, index) => index !== j)
    },
    addNumToList (num, index) {
      this.showError2 = true
      if (this.valid(num)) {
        this.exceptions[index].numbers.push({
          value: num,
          back: false
        })
        this.exceptions[index].num = ''
      }
    },
    addException () {
      this.exceptions.push({ num: '', message: '', numbers: [] })
    },
    activateOption (i) {
      this.options[i].checked = !this.options[i].checked
    },
    activateFeature () {
      this.tab = 0
      this.main.checked = !this.main.checked
      if (!this.main.checked) {
        for (let i = 0; i < this.options.length; i++) {
          this.options[i].checked = false
        }
      }
    },
    async showSuperClip () {
      if (this.showLoading) {
        return
      }
      this.showLoading = true
      const data = new FormData()
      data.append('gsm', this.$store.state.selectedNumber)
      try {
        const response = await this.superClipRepo.show(data)
        if (response.data.status === 200) {
          this.main.title = response.data.data.title
          this.main.description = response.data.data.description
          this.main.price = response.data.data.price === 0 ? this.$t('free') : response.data.data.price + this.$t('Bundles.sp')
          this.main.checked = response.data.data.serviceState === 1
          const customerState = response.data.data.customerState
          for (let i = 0; i < customerState.length; i++) {
            if (customerState[i].type === 0) {
              this.options[3].checked = customerState[i].state === 1
            } else if (customerState[i].type === 1) {
              this.options[0].checked = customerState[i].state === 1
            } else if (customerState[i].type === 2) {
              this.options[2].checked = customerState[i].state === 1
            } else if (customerState[i].type === 3) {
              this.options[1].checked = customerState[i].state === 1
            }
          }
          // ms.successMessage(response.data.message)
        } else {
          // ms.errorMessage(response.data.message)
        }
      } catch (e) {
        try {
          if (e.response.data) {
            // ms.errorMessage(e.response.data.message)
          }
        } catch {
          // ms.errorMessage('Sorry Something Went Wrong')
        }
      }
      this.showLoading = false
    },
    async showAutoReply () {
      if (this.showLoading) {
        return
      }
      this.showLoading = true
      const data = new FormData()
      data.append('gsm', this.$store.state.selectedNumber)
      try {
        const response = await this.superClipRepo.showAutoReply(data)
        if (response.data.status === 200) {
          this.general = response.data.data.generalMessage
          const others = response.data.data.others
          this.exceptions = []
          for (let i = 0; i < others.length; i++) {
            // this.exceptions[i].message = others[i].message
            this.exceptions.push({
              message: others[i].message,
              numbers: [],
              num: ''
            })
            // this.exceptions[i].num = others[i].numbers[0]
            // this.exceptions[i].numbers = others[i].numbers
            for (let m = 0; m < others[i].numbers.length; m++) {
              this.exceptions[i].numbers[m] = {
                value: others[i].numbers[m],
                back: true
              }
            }
          }
          // ms.successMessage(response.data.message)
        } else {
          // ms.errorMessage(response.data.message)
        }
      } catch (e) {
        try {
          if (e.response.data) {
            // ms.errorMessage(e.response.data.message)
          }
        } catch {
          // ms.errorMessage('Sorry Something Went Wrong')
        }
      }
      this.showLoading = false
    },
    async lastDayCallers () {
      this.callerGsm = ''
      this.filterType = { id: 0, name: '1 Day' }
      if (this.showLoading) {
        return
      }
      this.showLoading = true
      const data = new FormData()
      data.append('gsm', this.$store.state.selectedNumber)
      data.append('gsmFilter', this.callerGsm)
      data.append('dateFilterType', this.filterType.id)
      try {
        const response = await this.superClipRepo.showMyCallers(data)
        if (response.data.status === 200) {
          this.callersList = response.data.data.data
          // ms.successMessage(response.data.message)
        } else {
          // ms.errorMessage(response.data.message)
        }
      } catch (e) {
        try {
          if (e.response.data) {
            // ms.errorMessage(e.response.data.message)
          }
        } catch {
          // ms.errorMessage('Sorry Something Went Wrong')
        }
      }
      this.showLoading = false
    },
    async showCallers () {
      this.showError3 = true
      if (this.isLoading || (!this.valid(this.callerGsm) && this.callerGsm !== '')) {
        return
      }
      this.isLoading = true
      const data = new FormData()
      data.append('gsm', this.$store.state.selectedNumber)
      data.append('gsmFilter', this.callerGsm)
      data.append('dateFilterType', this.filterType.id)
      try {
        const response = await this.superClipRepo.showMyCallers(data)
        if (response.data.status === 200) {
          this.callersList = response.data.data.data
          ms.successMessage(response.data.message)
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        try {
          if (e.response.data) {
            ms.errorMessage(e.response.data.message)
          }
        } catch {
          ms.errorMessage('Sorry Something Went Wrong')
        }
      }
      this.isLoading = false
    },
    async handleSubmit1 () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      const formData = new FormData()
      formData.append('gsm', this.$store.state.selectedNumber)
      formData.append('serviceState', this.main.checked ? 1 : 0)
      for (let i = 0; i < this.options.length; i++) {
        if (i === 3) {
          formData.append('customerState[0].state', this.options[i].checked ? 1 : 0)
          formData.append('customerState[0].type', 0)
        } else if (i === 0) {
          formData.append('customerState[1].state', this.options[i].checked ? 1 : 0)
          formData.append('customerState[1].type', 1)
        } else if (i === 2) {
          formData.append('customerState[2].state', this.options[i].checked ? 1 : 0)
          formData.append('customerState[2].type', 2)
        } else if (i === 1) {
          formData.append('customerState[3].state', this.options[i].checked ? 1 : 0)
          formData.append('customerState[3].type', 3)
        }
      }
      try {
        const response = await this.superClipRepo.activate(formData)
        if (response.data.status === 200) {
          this.showSuperClip()
          ms.successMessage(response.data.message)
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        try {
          if (e.response.data) {
            ms.errorMessage(e.response.data.message)
          }
        } catch {
          ms.errorMessage('Sorry Something Went Wrong')
        }
      }
      this.isLoading = false
    },
    async handleAutoReply () {
      if (this.isLoading) {
        return
      }
      this.isLoading = true
      const formData = new FormData()
      formData.append('gsm', this.$store.state.selectedNumber)
      formData.append('generalMessage', this.general)
      for (let i = 0; i < this.exceptions.length; i++) {
        if (this.exceptions[i].message !== '') {
          formData.append(`others[${i}].message`, this.exceptions[i].message)
        }
        for (let k = 0; k < this.exceptions[i].numbers.length; k++) {
          if (this.exceptions[i].message !== '') {
            formData.append(`others[${i}].numbers[${k}]`, this.exceptions[i].numbers[k].value)
          }
        }
      }
      try {
        const response = await this.superClipRepo.activateAutoReply(formData)
        if (response.data.status === 200) {
          this.showAutoReply()
          ms.successMessage(response.data.message)
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        try {
          if (e.response.data) {
            ms.errorMessage(e.response.data.message)
          }
        } catch {
          ms.errorMessage('Sorry Something Went Wrong')
        }
      }
      this.isLoading = false
    },
    style () {
      setTimeout(() => {
        if (this.$lang === 'ar') {
          $('#super-clip').css('font-family', 'Mtn-arabic-regular')
          $('#super-clip .featureTitle').css('font-family', 'Mtn-arabic-regular')
          $('#super-clip .titleName').css('font-family', 'Mtn-arabic-regular')
          $('#super-clip .description').css('text-align', 'right')
          $('#super-clip .theme--light.v-tabs > .v-tabs-bar').css('font-family', 'Mtn-arabic-regular')
        } else {
          $('#super-clip').css('font-family', 'Mtn-regular')
          $('#super-clip .featureTitle').css('font-family', 'Mtn-regular')
          $('#super-clip .titleName').css('font-family', 'Mtn-regular')
          $('#super-clip .theme--light.v-tabs > .v-tabs-bar').css('font-family', 'Mtn-regular')
        }
      })
    }
  },
  watch: {
    tab (val) {
      if (val === 1 && this.counter === 0) {
        this.showAutoReply()
        this.counter++
      } else if (val === 2 && this.counter2 === 0) {
        this.lastDayCallers()
        this.counter2++
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
@media screen and (max-width: 400px){
  .item {
    font-size: 12px;
  }
}
.validation {
  width: 100%;
}
.exceptions:last-child .yellow-divider {
  background: none!important;
}
.yellow-divider {
  width: 80%;
  background: rgba(255, 203, 5, 0.5);
  height: 2px;
}
.add-num, .delete-num {
  color: $--yellow; cursor: pointer;
  font-weight: bold;
}
.add-num {
  color: $--yellow; cursor: pointer;
  font-size: 19px;
}
.num-item {
  margin: 4px;
  width: 140px;
  padding: 0px 9px;
  font-size: 12px;
  align-items: center;
  display: flex;
  height: 31px;
  justify-content: space-around;
  background: #ffff;
  border-radius: 13px;
  img {
    width: 17px !important;
  }
}
.callers-layout {
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(15px);
  position: absolute;
  top: 0px;
  right: 0;
  z-index: -1;
  width: 100%;
  padding-bottom: 2rem;
}
.add-excep {
  color: $--yellow; font-weight: bold;
  text-decoration: underline;
  margin-top: 1rem;
  cursor: pointer;
}
.super-note {
  font-style: italic;
  font-size: 13px;
  color: #707070;
}
.rotate {
  transform: rotate(180deg);
}
.spinner-border {
  color: $--yellow !important;
}
.opacity-layout {
  //border-top-right-radius: 22px; border-top-left-radius: 22px;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
  left: 0;
  backdrop-filter: blur(40px);
  background-image: linear-gradient(to bottom, rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
  -moz-background-image: -moz-linear-gradient(to bottom, rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
  -o-background-image: -o-linear-gradient(to bottom,rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
  -webkit-background-image: -webkit-linear-gradient(to bottom, rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
}
.cancel, .submit {
  font-size: 15px; text-decoration: underline; cursor: pointer;
}
.submit {
  color: $--yellow; font-weight: bold;
}
.border-cont {
  height: 2px; width: 100%;
  background: rgba(29, 29, 29, 0.30);
  margin: 1.5rem 0;
}
.input-cont {
  padding: 0 18px;
  display: flex!important; justify-content: center; align-items: center;
  margin-top: 0.8rem;
  border: 2px rgba(29, 29, 29, 0.75) solid;
  border-radius: 18px;
  //height: 55px;
  //width: 430px;
  height: 50px;
  width: 410px;
  input {
    padding: 0 10px;
    width: 100%; height: 100%;
  }
  img {
    width: 20px;
  }
}
.input-cont-1 {
  padding: 0 18px;
  //display: flex!important; justify-content: center; align-items: center;
  margin-top: 0.8rem;
  border: 2px rgba(29, 29, 29, 0.75) solid;
  border-radius: 18px;
  //height: 55px;
  //width: 430px;
  height: 50px;
  //width: 410px;
  input {
    padding: 0 10px;
    width: 100%; height: 100%;
  }
  img {
    width: 20px;
  }
}
//@media screen and (max-width: 1400px){
//  .input-cont {
//    width: 430px!important;
//  }
//}
@media screen and (max-width: 600px){
  .input-cont {
    width: 310px!important;
  }
}
@media screen and (max-width: 360px){
  .input-cont {
    width: 270px!important;
    margin: 1rem auto;
  }
}
.desc{
  font-style: italic;
  font-size: 13px;
}
.options-cont, .options-cont-2 {
  display: flex; align-items: center; justify-content: center;
  min-height: 300px;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.1);
  //border-top: 2.5px solid rgba(255, 255, 255, 0.75); border-top-right-radius: 22px; border-top-left-radius: 22px;
  padding: 50px 3rem 100px 3rem;
  width: 100%; backdrop-filter: blur(40px);
  //background-image: linear-gradient(to bottom, rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
  //-moz-background-image: -moz-linear-gradient(to bottom, rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
  //-o-background-image: -o-linear-gradient(to bottom,rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
  -webkit-background-image: -webkit-linear-gradient(to bottom, rgba(242, 242, 242, 0.5), rgba(225, 225, 225, 0.5));
}
.option {
  display: flex; align-items: center; justify-content: space-between;
  .name {
    font-size: 17px;
    font-weight: bold;
    color: $--yellow;
  }
  .ball-white-3 {
    width: 6px; height: 6px;
    background: $--yellow;
  }
}
@media screen and (max-width: 800px){
  .options-cont {
    padding: 35px 1.5rem 100px 1.5rem !important;
  }
  .options-cont-2 {
    padding: 35px 1.5rem 10rem 1.5rem !important;
  }
}
//#super-clip
#super-clip .main-cont {
  padding-top: 160px;
  background: url("../../assets/images/callForward.png") no-repeat;
  background-size: cover;
}
#super-clip .social-nav{
  height: 50px;
  background: rgba(242, 242, 242, 1);
  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
  margin: 0px 0px;
  display: flex;
  position: fixed;
  z-index: 10;
  z-index: 210;
  top: 110px;
}
#super-clip .nameContainer{
  width: 100vw;
  display: flex;
  padding: 0 4vw 0 3.2vw;
}
#super-clip .homeIcon {
  cursor: pointer;
}
.homeIcon,
.arrowIcon,
.titleName{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1vw;
}
#super-clip .titleName{
  width: max-content;
  color: $--yellow;
  //font-family: Mtn-bold;
  text-decoration: underline;
  font-weight: 900;
}
#super-clip .featureTitle{
  width: max-content;
  font-family: Mtn-regular;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1vw;
}
//switch button
.switch {
  font-size: 17px;
  position: relative;
  display: inline-block;
  width: 2.8em;
  height: 1.5em;
  border-radius: 50px;
  box-shadow: 10px 10px 20px rgba(0,0,0,0.08);
  background: #F2F2F2;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  border: 1px solid rgb(106,106,106);
  border-radius: 50px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  //filter: blur(1px);
}

.slider:before {
  position: absolute;
  content: "";
  height: 1em;
  width: 1em;
  left: 0.2em;
  bottom: 0.18em;
  background: rgb(106,106,106);
  border-radius: inherit;
  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
}
.slider-border {
  height: .95em;
  width: .95em;
  border: .8px solid #ffffff;
  border-radius: 50%;
  position: absolute;
  left: 0.295em;
  bottom: 0.25em;
  filter: blur(1px);
  transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
  cursor: pointer;
}

.switch input:checked + .slider:before {
  transform: translateX(1.2em);
  background-color: $--yellow;
}
/*---------------------------------*/
/*---------------------------------*/
.wrapper {
  padding: 0 3rem 2.5rem 3rem;
}
.flexing {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.titles {
  font-style: italic;
  color: $--yellow;
  font-size: 22px
}
.mini-title > span:first-child {
  font-size: 16px
}
.mini-title > span:last-child {
  font-size: 17px
}
.description {
  width: 100%;
  font-size: 13px;
  padding: 1rem  0;
  color: #707070;
}
/*----------------- responsive -------------------------*/
@media (max-width: 800px) {
  .wrapper {
    padding: 0 1.5rem 2.5rem 1.5rem;
  }
}
/*-------------------------------------------------------*/
.feature-footer {
  position: absolute; bottom: 0; width: 100%; display: flex;
  justify-content: space-between; align-items: center;
  height: 58px;
  background: #F6F6F6;
  padding: 0 4vw;
}
</style>
<style lang="scss">
@import "src/assets/sass/main";
#super-clip .tabs-white-border {
  width: calc(100% - 10vw); height: 2px;
  background: rgba(255, 255, 255, 0.75);
  position: absolute; bottom: 0;
}
#super-clip .theme--light.v-tabs > .v-tabs-bar {
  background: transparent !important;
  height: 70px;
  font-family: inherit !important;
  font-size: 13px !important;
}
#super-clip .tabs-cont {
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(15px);
  padding: 0 5vw;
  border-top-right-radius: 22px;
  border-top-left-radius: 22px;
  border-top: 2.5px solid rgba(255, 255, 255, 0.75);
}
#super-clip .v-tab--active {
  font-weight: bold !important; color: $--yellow !important;
}
#super-clip .theme--light.v-tabs-items {
  background: transparent !important;
}
#super-clip .v-slide-group__content {
  justify-content: center !important;
  //align-items: end;
  //padding-bottom: 0.7rem;
}
#super-clip .v-tabs-slider {
  background: $--yellow !important;
}
#super-clip .v-slide-group__prev {
  display: none;
}
@media screen and (max-width: 390px) {
  #super-clip .v-tab {
    padding: 0!important;
  }
}
#super-clip .p-dropdown {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
#super-clip .p-dropdown-items {
  background: white;
  border-radius: 13px;
  padding: 0;
  li {
    padding: 8px;
  }
}
#super-clip .pi-chevron-down:before {
  color: $--yellow;
}
</style>
